import { createFileRoute } from "@tanstack/react-router";
import { ExerciseLayout } from "@/components/exercise-layout";

export const Route = createFileRoute("/omo")({
  component: () => <ExerciseLayout id="omo" />,
});
